/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;
  /** @type {string[]} Fallback for restricted or full browser storage. */
  static #products = [];
  static #storageAvailable = true;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    this.#products = viewedProducts;
    try {
      if (this.#storageAvailable) localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch {
      this.#storageAvailable = false;
    }
  }

  static clearProducts() {
    this.#products = [];
    try {
      if (this.#storageAvailable) localStorage.removeItem(this.#STORAGE_KEY);
    } catch {
      this.#storageAvailable = false;
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      if (this.#storageAvailable) {
        const stored = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
        this.#products = Array.isArray(stored)
          ? stored.filter((id) => typeof id === 'string').slice(0, this.#MAX_PRODUCTS)
          : [];
      }
    } catch {
      this.#storageAvailable = false;
    }
    return [...this.#products];
  }
}
